import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  styled,
} from "@mui/material";

const StyledFormControl = styled(FormControl)(() => ({
  minWidth: 120,
  marginBottom: "16px",
  "& .MuiInputLabel-root": {
    fontSize: "14px",
  },
  "& .MuiSelect-select": {
    fontSize: "14px",
  },
}));

interface QuestionDropdownProps {
  questionNumber: number;
  options: string[];
  value: string;
  onChange: (value: string) => void;
  onFocus: (questionNumber: number) => void;
}

function QuestionDropdown({
  questionNumber,
  options,
  value,
  onChange,
  onFocus,
}: QuestionDropdownProps) {

  return (
    <StyledFormControl fullWidth onFocus={() => onFocus(questionNumber)}>
      <InputLabel id={`question-${questionNumber}-label`}>
        Select Answer
      </InputLabel>
      <Select
        labelId={`question-${questionNumber}-label`}
        id={`question-${questionNumber}-select`}
        value={value}
        label="Select Answer"
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((option, index) => (
          <MenuItem key={index} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </StyledFormControl>
  );
}

export default QuestionDropdown;
